import { Injectable } from '@angular/core';
import { ApiInterface, ApiQueryParamsDTO } from '../api-interface';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';

import { ItemDTO, PageItemConsultaDTO } from '../../models/item.model';

@Injectable({
  providedIn: 'root',
})
export class ItemsService implements ApiInterface {
  constructor(private apiService: ApiService) {}

  get<T>(
    url: string,
    data?: ApiQueryParamsDTO
  ): Observable<PageItemConsultaDTO> {
    const queryParams = this.apiService.buildQueryParams(data);
    const patch = queryParams ? `${url}?${queryParams}` : url;
    return this.apiService.read<PageItemConsultaDTO>(patch);
  }

  getFilter<T>(
    url: string,
    data?: { pessoa_id: number } & ApiQueryParamsDTO
  ): Observable<PageItemConsultaDTO> {
    const queryParams = this.apiService.buildQueryParams(data);
    const patch = queryParams ? `${url}?${queryParams}` : url;
    return this.apiService.read<PageItemConsultaDTO>(patch);
  }

  getById<T>(url: string, id: string): Observable<ItemDTO> {
    return this.apiService.read<ItemDTO>(`${url}/${id}`);
  }

  post<T>(url: string, data: ItemDTO): Observable<ItemDTO> {
    return this.apiService.create<ItemDTO>(url, data);
  }

  put<T>(url: string, data: ItemDTO): Observable<ItemDTO> {
    return this.apiService.update<ItemDTO>(url, data);
  }

  delete<T>(url: string): Observable<any> {
    return this.apiService.delete(url);
  }
}
